// extracted by mini-css-extract-plugin
export default {"container":"MedicineModal_container__V+sqb","content":"MedicineModal_content__JQRFx","buttons":"MedicineModal_buttons__e7U4M"};